import 'css-chunksrc/client/pages/projectPage/documentsPage/reportsPage/loader/styles.scss';export default {
  "reportsList": "_reportsList_1eklz_1"
};